/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';

interface Video {
  email: (email: string) => void;
  bind: (str: string, funct: (type: string, userEmail: string) => void) => void;
  remove: () => void;
}

interface Props {
  hashedId: string;
  embedOptions?: {};
}

const WistiaEmbed = ({ hashedId, embedOptions }: Props) => {
  if (typeof window !== 'undefined') {
    window._wq = window._wq || [];
    window._wq.push({
      id: hashedId,
      options: embedOptions
    });
  }

  useEffect(() => {
    let handle: Video;

    if (!document.getElementById('wistia_script')) {
      const wistiaScript = document.createElement('script');
      wistiaScript.id = 'wistia_script';
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      wistiaScript.async = true;
      document.body.appendChild(wistiaScript);
    }

    window._wq = window._wq || [];
    window._wq.push({
      id: hashedId,
      onEmbedded: (video: Video) => {
        handle = video;
        const email = window.Wistia.localStorage('golden-ticket');
        if (email) {
          handle.email(email);
        }

        handle.bind('conversion', (type: string, userEmail: string) => {
          if (/^(pre|mid|post)-roll-email$/.test(type)) {
            window.Wistia.localStorage('golden-ticket', userEmail);
            const videos = window.Wistia.api.all();
            const { length } = videos;
            for (let i = 0; i < length; i += 1) {
              videos[i].email(userEmail);
            }
          }
        });
      }
    });

    return () => {
      if (handle) {
        handle.remove();
      }
    };
  });

  return (
    <div
      className="wistia_responsive_padding"
      style={{ padding: '56.25% 0 0 0', position: 'relative' }}
    >
      <div
        className="wistia_responsive_wrapper"
        style={{
          height: '100%',
          left: '0',
          position: 'absolute',
          top: '0',
          width: '100%'
        }}
      >
        <div
          className={`wistia_embed wistia_async_${hashedId} videoFoam=true`}
          style={{ height: '100%', width: '100%' }}
        >
          &nbsp;
        </div>
      </div>
    </div>
  );
};

export default WistiaEmbed;
